import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const values = [
  { icon: 'ri-focus-3-line', title: '内容为先', desc: '只筛选剧情扎实、画工精湛的作品，让每一部上架漫画都值得花时间。' },
  { icon: 'ri-timer-line', title: '效率更新', desc: '优化排版与加载速度，热门连载第一时间同步，减少无谓等待。' },
  { icon: 'ri-shield-check-line', title: '版权尊重', desc: '坚持正版合作与内容规范，尊重每一位作者与作品的付出。' },
  { icon: 'ri-user-heart-line', title: '读者至上', desc: '认真倾听读者反馈，持续优化推荐与阅读体验，做懂你的追漫社区。' },
];

const milestones = [
  { year: '2021', text: '韩漫星球上线，专注韩国漫画分类整理与推荐。' },
  { year: '2023', text: '完成五大分类体系建设，接入每日自动更新能力。' },
  { year: '2025', text: '累计收录数千部作品，成为深受读者喜爱的追漫平台。' },
  { year: '2026', text: '持续打磨阅读体验，让每一部好漫画都能被看见。' },
];

const testimonials = [
  { name: '小鹿', role: '爱情漫画爱好者', text: '在这里找到好几部超甜的韩漫，分类很清晰，更新也及时，通勤路上追漫特别方便。', stars: 5 },
  { name: '阿泽', role: '动作漫迷', text: '热度榜挺靠谱的，跟着榜单读基本不踩雷，画面清晰，加载也快，体验很好。', stars: 5 },
  { name: 'Cici', role: '悬疑小说迷', text: '悬疑区的编排很用心，反转向的作品整理得特别全，收藏夹都快放不下了。', stars: 4 },
];

export default function About() {
  return (
    <>
      <Seo
        title="关于我们 - 韩漫星球 | 韩国漫画网"
        description="韩漫星球是专注韩国漫画分类与推荐的在线阅读平台，坚持内容为先、效率更新、版权尊重与读者至上，为你提供爱情、奇幻、动作、校园、悬疑等全部分类的高质量韩漫阅读体验。"
        keywords="韩漫星球,关于我们,韩国漫画网,漫画平台,漫画推荐"
        canonicalPath="/about"
        type="website"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于韩漫星球',
            description: '韩漫星球是专注韩国漫画分类与推荐的在线阅读平台。',
            url: typeof window !== 'undefined' ? `${window.location.origin}/about` : '/about',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩漫星球',
            url: typeof window !== 'undefined' ? window.location.origin : '/',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'service@hancomic.example',
              contactType: 'customer support',
            },
          },
        ]}
      />

      <Navbar />

      <main className="pt-20 md:pt-24">
        <section className="relative overflow-hidden bg-background-900">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20open%20comic%20books%20and%20floating%20pages%20in%20warm%20gold%20and%20coral%20light%2C%20creative%20abstract%20background%20for%20an%20about%20page%2C%20soft%20depth%20of%20field%2C%20high%20detail%20digital%20art%2C%20landscape%20composition&width=1600&height=700&seq=about-banner&orientation=landscape"
              alt=""
              aria-hidden="true"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="relative z-10 mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24 text-center">
            <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-secondary-300">
              <span className="h-px w-6 bg-secondary-400"></span> 关于我们 <span className="h-px w-6 bg-secondary-400"></span>
            </p>
            <h1 className="mx-auto mt-4 max-w-3xl font-heading text-3xl text-background-50 md:text-5xl leading-snug">
              让每一部好漫画，都被认真对待
            </h1>
            <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-background-200 md:text-base md:leading-8">
              韩漫星球，一个专注韩国漫画分类与推荐的内容平台。我们相信好的作品值得被更多人看见，也相信便捷的分类与清晰的榜单，能让每一位读者更快找到心仪的漫画。
            </p>
          </div>
        </section>

        <section className="bg-background-50 py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
              <div>
                <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
                  <span className="h-px w-6 bg-primary-500"></span> 我们的定位
                </p>
                <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-900">做一座连接读者与好漫画的桥梁</h2>
                <p className="mt-4 text-sm leading-8 text-foreground-600">
                  面对海量且不断新增的韩国漫画，读者往往不知道从何读起。韩漫星球从分类出发，将爱情、奇幻、动作、校园、悬疑等题材系统化梳理，结合评分、人气与编辑推荐，帮助每个人快速定位到自己感兴趣的题材与作品。
                </p>
                <p className="mt-3 text-sm leading-8 text-foreground-600">
                  我们不追求数量上的堆砌，而是希望通过更精准的整理与更真诚的推荐，让好作品被看见、被喜欢、被记住。
                </p>
              </div>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {values.map((v) => (
                  <div key={v.title} className="rounded-2xl border border-background-200 bg-background-100 p-5">
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                      <i className={`${v.icon} text-xl`}></i>
                    </span>
                    <h3 className="mt-3 font-heading text-lg text-foreground-900">{v.title}</h3>
                    <p className="mt-2 text-sm leading-6 text-foreground-500">{v.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="text-center">
              <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-600">
                <span className="h-px w-6 bg-accent-500"></span> 发展历程
              </p>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-900">一路走来的每一步</h2>
            </div>
            <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
              {milestones.map((m) => (
                <div key={m.year} className="relative rounded-2xl border border-background-200 bg-background-50 p-6">
                  <span className="font-heading text-3xl text-primary-500">{m.year}</span>
                  <p className="mt-3 text-sm leading-6 text-foreground-600">{m.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="text-center">
              <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-secondary-600">
                <span className="h-px w-6 bg-secondary-500"></span> 读者口碑
              </p>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-900">来自读者的真实声音</h2>
            </div>
            <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-100 p-6">
                  <div className="flex gap-1 text-secondary-500">
                    {Array.from({ length: t.stars }).map((_, i) => (
                      <i key={i} className="ri-star-fill"></i>
                    ))}
                  </div>
                  <blockquote className="mt-4 text-sm leading-7 text-foreground-600">"{t.text}"</blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-background-50">
                      {t.name[0]}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="rounded-3xl border border-background-200 bg-background-50 p-8 md:p-10 text-center">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">联系我们</h2>
              <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-foreground-500">
                无论是对网站的改进建议，还是内容合作意向，欢迎通过邮件与我们取得联系，我们会认真阅读每一条反馈。
              </p>
              <a
                href="mailto:service@hancomic.example"
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-send-line"></i> service@hancomic.example
              </a>
              <div className="mt-6">
                <Link to="/category" className="inline-flex items-center gap-1 text-sm font-semibold text-accent-600 hover:text-accent-700">
                  去逛逛漫画分类 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}